import React, { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { IApplicationState } from '../../store';
import { CanUserAccessFeature, FeatureFlags } from '../../utilities/FeatureFlags';

interface IRoutedFeatureProps {
	flag: keyof typeof FeatureFlags;
}

export const RoutedFeature = ({ flag, children }: PropsWithChildren<IRoutedFeatureProps>) => {
	const { user } = useSelector((state: IApplicationState) => state.oidc);
	return CanUserAccessFeature(user, flag) ? <>{children}</> : <Redirect to={{ pathname: '/' }} />;
};
